import {getMessages} from '../../../../../../store/constants';

export const NAVIGATION_PANEL_ASSIGNED_TO_ME_TITLE = getMessages().getText('assigned_to_me.title');
export const NAVIGATION_PANE_NEW_CARDS = getMessages().getText('assigned_to_me.newCards');
export const NAVIGATION_PANE_NEW_CARDS_HINT = getMessages().getText('assigned_to_me.newCards.hint');
